import { Stack, styled, Typography } from '@mui/material';

import palette from '../theme/palette';

export const HeadsUpWrapper = styled(Stack)({
  width: '100%',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  background:
    'linear-gradient(47deg, rgba(54, 110, 233, 0.05) 0%, rgba(175, 131, 249, 0.05) 36.54%, rgba(113, 93, 230, 0.05) 66.83%, rgba(126, 76, 220, 0.05) 100%)',
  gap: 8,
  padding: '6px 8px',
  borderRadius: 6,
  border: `1px solid ${palette.blue[1300]}`
});

interface AttentionProps {
  title?: string;
  description: string;
}

const Attention = ({ title, description }: AttentionProps) => {
  return (
    <HeadsUpWrapper>
      <Stack>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" viewBox="0 0 16 16" fill="none">
        <path
          d="M8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.682 1.33325 14.6668 4.31802 14.6668 7.99992C14.6668 11.6818 11.682 14.6666 8.00016 14.6666ZM8.00016 13.3333C10.9457 13.3333 13.3335 10.9455 13.3335 7.99992C13.3335 5.0544 10.9457 2.66659 8.00016 2.66659C5.05464 2.66659 2.66683 5.0544 2.66683 7.99992C2.66683 10.9455 5.05464 13.3333 8.00016 13.3333ZM7.3335 9.99992H8.66683V11.3333H7.3335V9.99992ZM7.3335 4.66659H8.66683V8.66659H7.3335V4.66659Z"
          fill="url(#paint0_linear_13035_35657)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_13035_35657"
            x1="1.3335"
            y1="14.6666"
            x2="15.1176"
            y2="1.81676"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#366EE9" />
            <stop offset="0.365385" stopColor="#AF83F9" />
            <stop offset="0.668269" stopColor="#715DE6" />
            <stop offset="1" stopColor="#7E4CDC" />
          </linearGradient>
          </defs>
        </svg>
      </Stack>
      <Typography fontSize={12} color={palette.grey[500]}>
        <span style={{ fontWeight: 700 }}>{title}</span>
        {description}
      </Typography>
    </HeadsUpWrapper>
  );
};

export default Attention;
